import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MplButton } from '../../atoms/MplButton/MplButton';
import { MplModal } from '../MplModal';

export const useDiscardChangesPrompt = (
	confirmedCallback: () => void,
	hasChanges: boolean
) => {
	const { t } = useTranslation(['discardChangesPrompt']);
	const [confirmDiscardChanges, setConfirmDiscardChanges] = useState(false);

	const guardedTrigger = useCallback(() => {
		if (hasChanges) {
			setConfirmDiscardChanges(true);
		} else {
			confirmedCallback();
		}
	}, [confirmedCallback, hasChanges]);

	const confirmClose = useCallback(() => {
		setConfirmDiscardChanges(false);
		confirmedCallback();
	}, [confirmedCallback]);

	return {
		confirmDiscardChanges: guardedTrigger,
		DiscardChangesConfirmationPrompt: (
			<MplModal
				testId="useDiscardChangesPrompt-MplModal"
				open={confirmDiscardChanges}
				title={t('header')}
				content={t('content')}
				buttons={
					<>
						<MplButton fullWidth onClick={confirmClose}>
							{t('button.submit')}
						</MplButton>
						<MplButton
							fullWidth
							variant="outlined"
							onClick={() => setConfirmDiscardChanges(false)}
						>
							{t('button.cancel')}
						</MplButton>
					</>
				}
			/>
		),
	};
};
